import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { useEffect } from 'react';

import { RunsPage } from '../../pages/events';
import {
  parseRunColumns,
  parseRunFilters,
  rememberRunColumns,
  rememberedRunColumns,
  runColumnsToSearch,
  runFiltersToSearch,
  type IRunColumns,
  type IRunFilters,
} from '../../entities/run';
import { useSession } from '../../entities/session';

export const Route = createFileRoute('/_shell/events')({
  validateSearch: (search: Record<string, unknown>) => search,
  component: function EventsRoute() {
    const search = Route.useSearch();
    const navigate = useNavigate();
    const session = useSession();
    const filters = parseRunFilters(search);

    // A URL naming no columns is the sidebar link; one that names them is somebody's.
    const silent = search.cols === undefined && search.paths === undefined;
    const picked = (silent ? rememberedRunColumns() : null) ?? parseRunColumns(search);
    const restored = runColumnsToSearch(picked);
    const restoredKey = JSON.stringify(restored);
    useEffect(() => {
      if (!silent || Object.keys(restored).length === 0) return;
      void navigate({ to: '/events', search: { ...search, ...restored }, replace: true });
    }, [silent, restoredKey]);

    return (
      <RunsPage
        filters={filters}
        picked={picked}
        onPicked={(next: IRunColumns) => {
          rememberRunColumns(next);
          void navigate({
            to: '/events',
            search: { ...runFiltersToSearch(filters), ...runColumnsToSearch(next) },
          });
        }}
        timeZone={session.data?.preferences.timezone}
        onFilters={(next: IRunFilters) =>
          void navigate({ to: '/events', search: { ...runFiltersToSearch(next), ...restored } })
        }
        onOpen={(run, copy) =>
          void navigate({
            to: '/events/runs/$runId',
            params: { runId: run.id },
            search: { ...runFiltersToSearch(filters), at: run.at, ...(copy && { copy: copy.id }) },
          })
        }
      />
    );
  },
});
